import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MessageBox from '../../common/components/MessageBox';
import { Button } from 'react-bootstrap';

class ConfirmationButton extends Component {
	constructor(props) {
		super(props);
		this.showConfirmation = this.showConfirmation.bind(this);
		this.hideConfirmation = this.hideConfirmation.bind(this);
		this.state = { showConfirmation: false };
	}

	showConfirmation() {
		this.setState({ showConfirmation: true });
	}

	hideConfirmation() {
		this.setState({ showConfirmation: false });
	}

	render() {
		const { onConfirmation, confirmationTitle, confirmationMessage, children, ...props } = this.props;
		return <React.Fragment>
			<Button onClick={this.showConfirmation} {...props}>{children}</Button>
			<MessageBox
				show={this.state.showConfirmation}
				title={confirmationTitle}
				message={confirmationMessage}
				onConfirm={() => {
					this.hideConfirmation();
					onConfirmation();
				}}
				onCancel={this.hideConfirmation}
			/>
		</React.Fragment>;
	}
}

ConfirmationButton.propTypes = {
	onConfirmation: PropTypes.func,
	confirmationTitle: PropTypes.string,
	confirmationMessage: PropTypes.string
};

export default ConfirmationButton;